import { ChatUIEnhancementContentCard } from 'Assistant/__generated__/client.schemas';
import { Tool } from 'Explore/types';
import { extractSlugNameFromPath } from './extractSlugNameFromPath';

export const mapContentCardToTool = (
  card: ChatUIEnhancementContentCard,
): Tool => ({
  __typename: 'Tool',
  id: card.id,
  title: card.title,
  slug: extractSlugNameFromPath(card.slug),
  summary: card.summary,
  estimatedMins: card.estimated_mins,
  cloudinaryThumbnail: card.thumbnail ? { path: card.thumbnail } : undefined,
  mediaType: card.media_type ? { value: card.media_type } : undefined,
  exploreCategory: card.category
    ? {
        __typename: 'ExploreCategory',
        id: card.category.id,
        title: card.category.title,
        slug: extractSlugNameFromPath(card.category.slug),
        topLevelCategory: {
          __typename: 'ExploreCategory',
          id: card.category.id,
          title: card.category.title,
        },
      }
    : undefined,
  isFavourite: false,
});

export default mapContentCardToTool;
